import crypto from 'crypto';
import { utils } from 'eciesjs';
import store from '../store';

export async function getBetsFromLocalStorage() {
  const mnemonic = store.getState().wallet.mnemonic;

  if (!mnemonic) throw new Error('Mnemonic not set');

  const betIdsRaw = localStorage.getItem('betIds');
  const betIds = betIdsRaw ? betIdsRaw.split(',') : [];

  const mnemonicKey = crypto.createHash('sha256').update(mnemonic).digest();

  return betIds
    .map((id) => {
      const encryptedBet = localStorage.getItem(id);
      if (!encryptedBet) return null;

      const bet = JSON.parse(
        utils
          .aesDecrypt(mnemonicKey, Buffer.from(encryptedBet, 'base64'))
          .toString()
      );

      return bet;
    })
    .filter((x) => x);
}

export function getNumContracts() {
  const contractIdsRaw = localStorage.getItem('betIds');
  const contractIds = contractIdsRaw ? contractIdsRaw.split(',') : [];

  return contractIds.length;
}
